import React from 'react';
import PropTypes from 'prop-types';
import withStyles from '@tempus/component-library/utils/withStyles';
import { HeroButton } from '@tcl-boron-prefabs/hero-button';
import styles from './styles';
import { HubLogo } from './Logos/TempusLogoHub';
import { LensLogo } from './Logos/TempusLogoLens';
import { PixelRadLogo } from './Logos/TempusLogoPixelRad';
import { NextLogo } from './Logos/TempusLogoNext';
import { ApplicationNames } from '../../app-config/shared';

const logoWidth = '128px';
const logoHeight = '16px';

const renderTempusLogoWithApp = (appName) => {
  switch (appName) {
    case ApplicationNames.HUB:
      return <HubLogo width={logoWidth} height={logoHeight} />;
    case ApplicationNames.LENS:
      return <LensLogo width={logoWidth} height={logoHeight} />;
    case ApplicationNames.PIXEL_RAD:
      return <PixelRadLogo width={logoWidth} height={logoHeight} />;
    case ApplicationNames.NEXT_INTELLIGENCE:
    case ApplicationNames.NEXT_PLATFORM:
      return <NextLogo width={logoWidth} height={logoHeight} />;
    case ApplicationNames.DAVID:
      return <HubLogo width={logoWidth} height={logoHeight} />; // TBD on the David logo
    default:
      return null;
  }
};

const ApplicationCard = ({ classes, onClick, application }) => (
  <div className={classes.container} data-testid={`app-card`}>
    <HeroButton logo={renderTempusLogoWithApp(application)} onClick={onClick} ariaLabel={application} />
  </div>
);

ApplicationCard.propTypes = {
  onClick: PropTypes.func.isRequired,
  classes: PropTypes.object.isRequired,
  application: PropTypes.string.isRequired,
};

export default withStyles(styles)(ApplicationCard);
